import initCycleAnalytics from '~/cycle_analytics';

initCycleAnalytics();
